// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PaymentTermsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PaymentTermsQuery = { __typename?: 'Query', paymentTerms: Array<{ __typename?: 'PaymentTerm', id: string, name: string, description?: string | null | undefined, active: boolean, dueDay: number, alignWithPaymentCycle: boolean, dueFrom: { __typename?: 'PaymentTermDueFromDetail', name: string, code: Types.PaymentTermDueFrom } }>, paymentTermDueFromDetails: Array<{ __typename?: 'PaymentTermDueFromDetail', name: string, code: Types.PaymentTermDueFrom }> };

export type SavePaymentTermMutationVariables = Types.Exact<{
  input: Types.SavePaymentTermInput;
}>;


export type SavePaymentTermMutation = { __typename?: 'Mutation', savePaymentTerm: { __typename?: 'SavePaymentTermResult', paymentTerm: { __typename?: 'PaymentTerm', id: string } } };

export type PaymentTermFragment = { __typename?: 'PaymentTerm', id: string, name: string, description?: string | null | undefined, active: boolean, dueDay: number, alignWithPaymentCycle: boolean, dueFrom: { __typename?: 'PaymentTermDueFromDetail', name: string, code: Types.PaymentTermDueFrom } };

export const PaymentTermFragmentDoc = gql`
    fragment PaymentTerm on PaymentTerm {
  id
  name
  description
  active
  dueDay
  dueFrom {
    name
    code
  }
  alignWithPaymentCycle
}
    `;
export const PaymentTermsDocument = gql`
    query PaymentTerms {
  paymentTerms {
    ...PaymentTerm
  }
  paymentTermDueFromDetails {
    name
    code
  }
}
    ${PaymentTermFragmentDoc}`;

/**
 * __usePaymentTermsQuery__
 *
 * To run a query within a React component, call `usePaymentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentTermsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
      }
export function usePaymentTermsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
        }
// @ts-ignore
export function usePaymentTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaymentTermsQuery, PaymentTermsQueryVariables>;
export function usePaymentTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaymentTermsQuery | undefined, PaymentTermsQueryVariables>;
export function usePaymentTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
        }
export type PaymentTermsQueryHookResult = ReturnType<typeof usePaymentTermsQuery>;
export type PaymentTermsLazyQueryHookResult = ReturnType<typeof usePaymentTermsLazyQuery>;
export type PaymentTermsSuspenseQueryHookResult = ReturnType<typeof usePaymentTermsSuspenseQuery>;
export type PaymentTermsQueryResult = Apollo.QueryResult<PaymentTermsQuery, PaymentTermsQueryVariables>;
export const SavePaymentTermDocument = gql`
    mutation SavePaymentTerm($input: SavePaymentTermInput!) {
  savePaymentTerm(input: $input) {
    paymentTerm {
      id
    }
  }
}
    `;
export type SavePaymentTermMutationFn = Apollo.MutationFunction<SavePaymentTermMutation, SavePaymentTermMutationVariables>;

/**
 * __useSavePaymentTermMutation__
 *
 * To run a mutation, you first call `useSavePaymentTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePaymentTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePaymentTermMutation, { data, loading, error }] = useSavePaymentTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePaymentTermMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePaymentTermMutation, SavePaymentTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePaymentTermMutation, SavePaymentTermMutationVariables>(SavePaymentTermDocument, options);
      }
export type SavePaymentTermMutationHookResult = ReturnType<typeof useSavePaymentTermMutation>;
export type SavePaymentTermMutationResult = Apollo.MutationResult<SavePaymentTermMutation>;
export type SavePaymentTermMutationOptions = Apollo.BaseMutationOptions<SavePaymentTermMutation, SavePaymentTermMutationVariables>;